import React, { useEffect, useState } from 'react';

import { ApiList, CommonHash, Program, School } from 'app/types';

import styles from '../PersonalStatementBuilder.module.scss';
import Select from 'react-select';
import Text from 'common/components/Text/Text';

interface CompProps {
  setInputOption: (
    key: string,
    value: any,
    setStateFunction: (value: React.SetStateAction<CommonHash>) => void
  ) => void;
  setAnswers: React.Dispatch<React.SetStateAction<CommonHash>>;
  school: CommonHash;
  schoolsLoading: boolean;
  schoolsFetching: boolean;
  schools?: ApiList<School>;
  program: CommonHash;
  programsLoading: boolean;
  programsFetching: boolean;
  programs?: ApiList<Program>;
  setSchool: React.Dispatch<React.SetStateAction<any>>;
  setProgram: React.Dispatch<React.SetStateAction<any>>;
}

export const UniversityProgramStep = ({
  setInputOption,
  setAnswers,
  school,
  schoolsLoading,
  schoolsFetching,
  programsLoading,
  programsFetching,
  schools,
  program,
  programs,
  setSchool,
  setProgram,
}: CompProps): React.ReactElement => {
  const otherOption = { label: 'Other', value: 0 };
  const [otherSchoolChecked, setOtherSchoolChecked] = useState<boolean>(school.value === 0);

  const handleCheckboxOtherSchool = (checked: boolean) => {
    if (checked) {
      setOtherSchoolChecked(true);
      setAnswers((a: any) => ({ ...a, school_name: '' }));
      setSchool(otherOption);
    } else {
      setOtherSchoolChecked(false);
      setSchool({ label: '', value: -1 });
    }
  };

  // useEffect(() => {
  //   if (otherSchoolChecked) {
  //     if (school.label.length <= 0) {
  //       setAnswers((a: any) => ({ ...a, school_name: '' }));
  //       setSchool(otherOption);
  //     }
  //   }
  // }, [otherSchoolChecked]);

  useEffect(() => {
    if (school.value === 0) {
      setOtherSchoolChecked(true);
    }
  }, [school]);

  return (
    <>
      <div className={styles.stepTitle}>University & Program</div>
      <div className="d-flex flex-row gap-4">
        <div className="col d-flex flex-column">
          <div className={styles.statementQuestion}>What university are you applying to?</div>
          <Select
            isSearchable
            classNamePrefix="react-select"
            options={[...(schools?.data.map((c) => ({ label: c.name, value: c.id })) || [])]}
            isLoading={schoolsLoading || schoolsFetching}
            onChange={(school: any) => {
              setSchool(school);
              if (school.value !== 0) {
                setAnswers((a: any) => ({ ...a, school_name: school.label }));
                setOtherSchoolChecked(false);
                // setInputOption('school_name', school.label, setAnswers);
              } else {
                setAnswers((a: any) => ({ ...a, school_name: '' }));
                // setInputOption('school_name', '', setAnswers);
              }
            }}
            value={school.value === 0 ? otherOption : school}
          />
        </div>
        {school.value === 0 && (
          <div className="col d-flex flex-column">
            <div className={styles.statementQuestion}>Type university name</div>
            <input
              className={`form-control`}
              type="text"
              onChange={(e) => {
                setSchool({ label: e.target.value, value: 0 });
                setAnswers((a: any) => ({ ...a, school_name: e.target.value }));
              }}
              value={school.label === 'Other' ? '' : school.label}
              placeholder="University name"
            />
          </div>
        )}
      </div>
      <div className="d-flex flex-row align-items-center gap-2 mt-3">
        <input
          type="checkbox"
          name="opt_out"
          value="The University I want to apply is not in this list"
          className="form-check-input"
          checked={otherSchoolChecked}
          onChange={() => handleCheckboxOtherSchool(!otherSchoolChecked)}
          style={{ marginTop: '0' }}
        />
        <Text size={14} weight={600} inlineStyle={{ color: '#19234F' }}>
          The University I want to apply is not in this list
        </Text>
      </div>
      {school.value > -1 && (
        <>
          <div className="d-flex flex-row gap-4">
            <div className="col d-flex flex-column">
              <div className={styles.statementQuestion} style={{ marginTop: '40px' }}>
                What program are you applying for?
              </div>
              <Select
                isSearchable
                classNamePrefix="react-select"
                options={[
                  ...(school.value > 0
                    ? programs?.data.map((c) => ({ label: c.name, value: c.id })) || []
                    : []),
                  ...[otherOption],
                ]}
                isLoading={programsLoading || programsFetching}
                onChange={(program: any) => {
                  setProgram(program);
                  if (program.value !== 0) {
                    setAnswers((a: any) => ({ ...a, program_name: program.label }));
                  } else {
                    setAnswers((a: any) => ({ ...a, program_name: '' }));
                  }
                }}
                value={program.value === 0 ? otherOption : program}
              />
            </div>
            {program.value === 0 && (
              <div className="col d-flex flex-column">
                <div className={styles.statementQuestion} style={{ marginTop: '40px' }}>
                  Type program name
                </div>
                <input
                  className={`form-control`}
                  type="text"
                  onChange={(e) => {
                    setProgram({ label: e.target.value, value: 0 });
                    setAnswers((a: any) => ({ ...a, program_name: e.target.value }));
                  }}
                  value={program.label === 'Other' ? '' : program.label}
                  placeholder="Program name"
                />
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};
